import React, { useEffect, useState, useMemo } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Button,
  Box,
  TextField,
} from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
// import { FETCH_ECOSSYTEM_LOADING_POPUP } from "../../../../containers/actions/types";
// import { fetchEcosystemPopup } from "../../../../containers/actions/ecosystemActions";
// import { useDispatch } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import jwtDecode from "jwt-decode";
import ReconciliationOfInventoryDialog from "./ReconciliationOfInventoryDialog";

function InventoryStatusPopup(props) {

  const {
    open,
    onClose,
    plantCodesList,
    cmosList,
    setVendorData,
    initialSelectedCMO,
    sponsorLastUpdatedDate,
  } = props;

  const [selectedCMO, setSelectedCMO] = useState(null);
  const [selectedPlantCode, setSelectedPlantCode] = useState({ plantCode: "All" });
  const [selectedStorageLocationID, setSelectedStorageLocationID] = useState({ label: "Special Stocks with Vendor" });
  const [showReconciliation, setShowReconciliation] = useState(false);

  const getOrganizationIdFromToken = () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return null;

    try {
      const decodedToken = jwtDecode(authToken);
      return decodedToken.organization_id || null;
    } catch (error) {
      return null;
    }
  };

  const organizationIdFromToken = getOrganizationIdFromToken();

  useEffect(() => {
    if (open && initialSelectedCMO && initialSelectedCMO?.organizationId !== 'All') {
      const transformedCMO = {
        organizationName: initialSelectedCMO?.organizationName,
        organizationId: initialSelectedCMO?.organizationId
      };
      setSelectedCMO(transformedCMO);
    }
  }, [open, initialSelectedCMO]);

  const handleContinue = () => {
    setShowReconciliation(true);
    setVendorData({
      vendorMosymphonyID: selectedCMO?.organizationId || '',
      vendorPlant: "all",
    });
  };

  const handleBackToPopup = () => {
    setShowReconciliation(false);
  };

  const cmoOptions = cmosList?.CMOMembersWithId
    ? cmosList?.CMOMembersWithId.map((item) => ({
        organizationName: item?.organizationName,
        organizationId: item?.organizationId,
      }))
    : [];

  // const collabType = localStorage.getItem("collabType");

  // const filteredPlantCodesforCmo = plantCodesList?.data.filter(
  //   (plant) => plant?.vendorMosymphonyID === organizationIdFromToken
  // );

  // const filteredPlantCodes = selectedCMO
  //   ? plantCodesList?.data?.filter(
  //       (plant) => plant?.vendorMosymphonyID === selectedCMO?.organizationId
  //     )
  //   : [];


  const apiPayload = useMemo(() => ({
    brandOwnerMosymphonyID: organizationIdFromToken,
    vendorMosymphonyID: selectedCMO?.organizationId || '',
    vendorPlant: ["all"],
    collabrixReconciliationID: 0,
    materialTypeID: ["all"],
    sponsorMaterialCode: "all",
    filterRowsWith: "all"
  }), [organizationIdFromToken, selectedCMO?.organizationId]);

  if (showReconciliation) {
    return (
      <ReconciliationOfInventoryDialog 
        onBack={handleBackToPopup}
        onClose={onClose}
        cmoName={selectedCMO?.organizationName || ''}
        selectedCMO={selectedCMO}
        apiPayload={apiPayload}
        sponsorLastUpdatedDate={sponsorLastUpdatedDate}
      />
    );
  }

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "black",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "red")}
          onMouseOut={(e) => (e.currentTarget.style.color = "black")}
          onClick={onClose}
        >
          <Typography
            variant="h6"
            style={{
              color: "inherit",
              marginRight: "4px",
              fontWeight: 550,
              fontSize: "1rem",
            }}
          >
            Cancel
          </Typography>
          <CloseIcon
            onClick={onClose}
            style={{ color: "inherit", marginTop: "4px" }}
          />
        </Box>
      </DialogTitle>

      {cmosList?.status === false && plantCodesList?.status === false ? (
        <Grid
          style={{
            height: "350px",
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "120px",
          }}
        >
          <Typography
            style={{
              border: "2px solid rgb(255,0,0)",
              backgroundColor: "rgb(255,240,240)",
              Opacity: 1,
              textAlign: "center",
              padding: "0.8rem",
              fontSize: "0.875rem",
            }}
          >
            {"Something went wrong. Please contact Schrocken Support."}
          </Typography>
        </Grid>
      ) : (
        <DialogContent style={{ paddingLeft: "60px", paddingRight: "60px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ marginBottom: "15px" }}>
              <Typography
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Reconciliation of Inventory
              </Typography>
            </Grid>

            {/* CMO/CDMO Dropdown */}
            <Grid item xs={12} style={{ marginBottom: "15px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                CMO
                <span style={{ fontWeight: "bold", color: "red" }}>{" "}*</span>
              </Typography>
              {localStorage?.collabType === "CMO" ? (
                <Typography variant="body1">
                  {localStorage?.organizationName || "NA"}
                </Typography>
              ) : (
                <Autocomplete
                  size="small"
                  options={cmoOptions}
                  getOptionLabel={(option) => option.organizationName}
                  getOptionSelected={(option, value) => option.organizationId === value.organizationId}
                  value={selectedCMO}
                  onChange={(event, newValue) => {
                    setSelectedCMO(newValue);
                    setSelectedPlantCode({ plantCode: "All" });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select CMO"
                    />
                  )}
                  fullWidth
                />
              )}
            </Grid>

            <Grid item xs={12} style={{ marginBottom: "15px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Plant ID
              </Typography>
              <Autocomplete
                size="small"
                options={[{ plantCode: "All" }]}
                getOptionLabel={(option) => option.plantCode || ""}
                value={selectedPlantCode}
                onChange={(event, newValue) => setSelectedPlantCode(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="All"
                  />
                )}
                fullWidth
                disabled={true}
              />
            </Grid>

            {/* Storage Location ID Dropdown */}
            <Grid item xs={12} style={{ marginBottom: "15px" }}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Storage Location ID
              </Typography>
              <Autocomplete
                size="small"
                options={[{ label: "Special Stocks with Vendor" }]}
                getOptionLabel={(option) => option.label || ""}
                value={selectedStorageLocationID}
                onChange={(event, newValue) => setSelectedStorageLocationID(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Special Stocks with Vendor"
                  />
                )}
                fullWidth
                disabled={true}
              />
            </Grid>

            <Grid
              item
              xs={12}
              style={{ textAlign: "center", marginBottom: "12px" }}
            >
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{ borderRadius: "20px", textTransform: "capitalize" }}
                onClick={handleContinue}
                // onClick={() => handleEcosystemAddtion(true)}
                disabled={localStorage.collabType !== "CMO" && !selectedCMO}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      )}
    </Dialog>
  );
}

export default InventoryStatusPopup;